/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_Client_TwoInputs */

const en_features_sample_client_two = /** @type {(inputs: Features_Sample_Client_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michael Reed`)
};

const pl_features_sample_client_two = /** @type {(inputs: Features_Sample_Client_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michał Zieliński`)
};

/**
* | output |
* | --- |
* | "Michael Reed" |
*
* @param {Features_Sample_Client_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_client_two = /** @type {((inputs?: Features_Sample_Client_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_Client_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_client_two(inputs)
	return en_features_sample_client_two(inputs)
});